"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareGranteeContent = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var Typography_1 = require("../../../Typography");
var AddGranteeButton_1 = require("./AddGranteeButton");
var GranteeList_1 = require("./GranteeList");
var GranteeListLoading_1 = require("./GranteeListLoading");
/**
 * @internal
 */
exports.ShareGranteeContent = function (props) {
    var isLoading = props.isLoading, grantees = props.grantees, onAddGrantee = props.onAddGrantee, onDelete = props.onDelete;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "gd-share-dialog-grantee-content-header" },
            react_1.default.createElement(Typography_1.Typography, { tagName: "h3" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "shareDialog.share.grantee.list.title" })),
            react_1.default.createElement(AddGranteeButton_1.AddUserOrGroupButton, { onClick: onAddGrantee, isDisabled: isLoading })),
        isLoading ? (react_1.default.createElement(GranteeListLoading_1.GranteeListLoading, null)) : (react_1.default.createElement(GranteeList_1.GranteeList, { grantees: grantees, mode: "ShareGrantee", onDelete: onDelete }))));
};
//# sourceMappingURL=ShareGranteeContent.js.map